// extracted by mini-css-extract-plugin
export default {"container":"N1-z","heading":"O1-z","links":"P1-z","copy":"Q1-z","subCopy":"R1-z","linksLeft":"S1-z","linksCenter":"T1-z","linksRight":"U1-z","link":"V1-z","onlyLink":"W1-z"};